export const handwrittenfont = "Caveat, cursive";
export const turn = "rotate(-180deg)";
